import React, { Component } from "react";
import { Button, Container, Row, Col } from "reactstrap";

class ErrorPage extends Component {

    handleLogin(e) {
        e.preventDefault();
        this.props.history.replace("/login");
    }

    render() {
        return (
        <div className="app flex-row align-items-center">
            <Container>
            <Row className="justify-content-center">
                <Col md="6">
                <span className="clearfix">
                    <h1 className="float-left display-3 mr-4">{this.props.error.code}</h1>
                    <h4 className="pt-3">{this.props.error.title}</h4>
                    <p className="text-muted float-left">
                        {this.props.error.message}
                    </p>
                </span>
                    <Button
                    id="login"
                    color="link"
                    className="px-0"
                    onClick={this.handleLogin.bind(this)}
                    >
                    Revenir à l'accueil
                    </Button>
                </Col>
            </Row>
            </Container>
        </div>
        );
    }
}

export default ErrorPage;


// WEBPACK FOOTER //
// ./src/views/Pages/ErrorPage/ErrorPage.js